import history from './../history';

export default function (pathOrLocationDescriptor) {
    setTimeout(() => history.push(pathOrLocationDescriptor), 1);
}